import ResourceLoader from './ResourceLoader';

export default ResourceLoader;
